import useGetTrainingSet from '../hooks/useGetTrainingSet';
import { Chip, Tooltip, Typography } from '@mui/material';
import { Link } from 'react-router';
import { collapseString } from '../../utils/collapseString';
import ExtractionBatchRename from './actions/ExtractionBatchRename';
import { IExtractionBatch } from '../../types/my-types';
import SentBadge from '../common/SentBadge';
import CertifiedBadge from '../common/CertifiedBadge';
import CollapsedTitleWithTooltip from '../common/CollapsedTitleWithTooltip';
import TrainingSetDescriptionEdit from '../train/actions/TrainingSetDescriptionEdit';
import { getIdFromUrl } from '../../utils/getIdFromUrl';

interface IProps {
  extractionBatch: IExtractionBatch | undefined;
  ebCharLimit: number;
  dpid: string;
  eid: string;
}

const ExtractionBatchNameAndTS = ({ extractionBatch, ebCharLimit, dpid, eid }: IProps) => {
  const trainingSetId = getIdFromUrl(extractionBatch?.training_set);

  const { data: trainingSet, isLoading: isLoadingTrainingSet } = useGetTrainingSet(trainingSetId);

  const ebName = extractionBatch?.label
    ? collapseString(extractionBatch.label, ebCharLimit, ebCharLimit)
    : 'Loading...';

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Tooltip title={trainingSet?.tokenizer_version || 'Loading...'} placement="top">
            <Typography
              style={{ fontWeight: 'bold', fontSize: '18px', color: 'black' }}
              data-cy="lbl-extraction-batch-name"
            >
              {ebName}
            </Typography>
          </Tooltip>
          {extractionBatch && <ExtractionBatchRename extractionBatch={extractionBatch} />}
          {extractionBatch?.verified && (
            <SentBadge verified={extractionBatch.verified.updated_at} />
          )}
          {extractionBatch?.is_experimental && (
            <Chip
              label="EXPERIMENTAL"
              size="small"
              sx={{
                ml: 1,
                height: '20px',
                fontSize: '11px',
                fontWeight: 600,
                backgroundColor: '#e8f4fd',
                color: '#1565c0',
                border: '1px solid #90caf9',
              }}
              data-cy="chip-experimental"
            />
          )}
        </div>
        <div>
          <Typography style={{ fontSize: '13px', fontWeight: 'bold' }} component="div">
            {!trainingSet?.label || isLoadingTrainingSet ? (
              '...'
            ) : (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Link
                  to={`/data-pools/${dpid}/train/${trainingSetId}/details`}
                  style={{ color: 'rgb(102, 187, 169)', flexShrink: 0 }}
                >
                  <CollapsedTitleWithTooltip title={trainingSet?.label} charsFirstAndLast={25} />
                </Link>
                <CertifiedBadge
                  certifiedAt={trainingSet.certified_at}
                  certifiedBy={trainingSet.certified_by}
                />
                <TrainingSetDescriptionEdit
                  trainingSetId={trainingSet.id}
                  trainingSetDescription={trainingSet.description}
                  iconType="text"
                />
              </div>
            )}
          </Typography>
        </div>
      </div>
    </div>
  );
};
export default ExtractionBatchNameAndTS;
